import Link from '@components/Link';
import Styles from './Breadcrumbs.module.scss';

const Breadcrumbs = ({ items, children }) => (
  <div className={Styles.container}>
    <ul className={Styles.breadcrumb}>
      {items.map((v, idx) => (
        <li key={idx} className={Styles.item}>
          {v?.to ? <Link to={v?.to}>{v.text}</Link> : <>{v.text}</>}
        </li>
      ))}
    </ul>
    {children}
  </div>
);

export default Breadcrumbs;
